var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{style:({'padding':'0', width:_vm.width,height:_vm.height,'text-align': 'center', 'min-width': '32px'}),attrs:{"size":_vm.size,"type":_vm.type},on:{"click":function($event){return _vm.$emit('click',$event)}}},[_c('i',{staticClass:"el-icon-plus"})])
}
var staticRenderFns = []

export { render, staticRenderFns }